export function formatSabilAuditActionLabel(actionType: string | null | undefined): string {
  switch (String(actionType ?? "").toUpperCase()) {
    case "CREATE":
      return "Created";
    case "UPDATE":
      return "Updated";
    case "TRANSFER":
      return "Transfer";
    case "CLOSE":
      return "Closed";
    case "TRANSFER_OUT":
      return "Transfer out";
    case "RECEIPT_UPDATE":
      return "Receipt updated";
    case "RECEIPT_DELETE":
      return "Receipt deleted";
    default:
      return actionType ? String(actionType) : "—";
  }
}
